export enum StickyZoneTitlePosition {
  Top = 'Top',
  Bottom = 'Bottom',
  Left = 'Left',
  Right = 'Right',
}

const StickyZoneTitlePositionMap: { [key in StickyZoneTitlePosition]: StickyZoneTitlePosition } = {
  [StickyZoneTitlePosition.Top]: StickyZoneTitlePosition.Top,
  [StickyZoneTitlePosition.Bottom]: StickyZoneTitlePosition.Bottom,
  [StickyZoneTitlePosition.Left]: StickyZoneTitlePosition.Left,
  [StickyZoneTitlePosition.Right]: StickyZoneTitlePosition.Right,
} as const;

const StickyZoneTitlePositionList = Object.values(StickyZoneTitlePositionMap);

export namespace StickyZoneTitlePosition {
  export function values(): Readonly<StickyZoneTitlePosition[]> {
    return StickyZoneTitlePositionList;
  }

  export function load(value: string): StickyZoneTitlePosition {
    return isStickyZoneTitlePosition(value) ? value : StickyZoneTitlePosition.Top;
  }

  export function dump(position: StickyZoneTitlePosition): 'Top' | 'Bottom' | 'Left' | 'Right' {
    return position;
  }
}

function isStickyZoneTitlePosition(value: string): value is StickyZoneTitlePosition {
  return StickyZoneTitlePositionList.some((position) => value === position);
}
